import { Journey } from '../../lib/types/models/product/journey'
import { JourneyRequest } from '../../lib/types/models/product/journey-input'
import { IdInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const duplicateJourney = (data: IdInput<JourneyRequest>) => {
  const { id, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.products.duplicateJourney.url, { id }))
    .post<Journey, JourneyRequest>(rest)
}
